import { render } from "./discount-update.vue?vue&type=template&id=3f0b7462"
import script from "./discount-update.vue?vue&type=script&lang=js"
export * from "./discount-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__